// extracted by mini-css-extract-plugin
export default {"message":"ErrorText_message__misXE","icon":"ErrorText_icon__lWHcT"};